import comp from "./SideNavigation";
export default comp;
